(function () {
  var currentCurrency = Shopify.currency.active;
  var lastCurrency = localStorage.getItem('bundle_last_currency');

  if (lastCurrency && lastCurrency !== currentCurrency) {
    console.log('Currency changed:', lastCurrency, '→', currentCurrency);
    refreshBundlePricesInCart();
  }

  localStorage.setItem('bundle_last_currency', currentCurrency);

  async function refreshBundlePricesInCart() {
    try {
    
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();

     
      for (const item of cart.items) {
        if (!item.properties || !item.properties._bundle_variants) continue;

        
        let variantIds = [];
        try {
          variantIds = JSON.parse(item.properties._bundle_variants);
        } catch (e) {
          continue;
        }

        
        const newPrices = [];
        for (const gid of variantIds) {
          const variantId = gid.split('/').pop(); // "gid://shopify/ProductVariant/123" → "123"
          const res = await fetch(`/variants/${variantId}.js`);
          const variantData = await res.json();
          newPrices.push(variantData.price); 
        }

      
        const discount = Number(item.properties._bundle_discount || 0);
        const discountedPrices = newPrices.map(p =>
          Math.round(p * (100 - discount) / 100)
        );

       
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: item.key,
            quantity: item.quantity,
            properties: {
              ...item.properties,
              _bundle_prices: JSON.stringify(discountedPrices),
            },
          }),
        });
      }

      console.log('Bundle prices updated for new currency ✅');

      // ── Cart drawer/UI refresh  ──────────────────────────
      const res = await fetch(window.location.pathname + '?_=' + new Date().getTime());
      if (res.ok) {
        const htmlText = await res.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlText, 'text/html');
        const cartDrawer = document.querySelector('[data-drawer-right].cart');
        const newContent = doc.querySelector('[data-ajaxcart-content]');
        const currentContent = cartDrawer ? cartDrawer.querySelector('[data-ajaxcart-content]') : null;

        if (newContent && currentContent) {
          currentContent.innerHTML = newContent.innerHTML;
          const newCount = doc.querySelector('[data-cart-item-count]')?.innerText || '';
          document.querySelectorAll('[data-cart-item-count], [data-cart-icon-full]').forEach(el => {
            el.innerText = newCount;
            parseInt(newCount) > 0 ? el.classList.remove('hide') : el.classList.add('hide');
          });
        }
      }

    } catch (err) {
      console.error('Bundle price refresh failed:', err);
    }
  }
})();

if (!window.__productBundlePopupInit) {
  window.__productBundlePopupInit = true;

  function formatMoney(cents, format) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, format || window.theme?.moneyFormat || '${{amount}}');
    }
    const value = (cents / 100).toFixed(2);
    return '$' + value;
  }

  // Works for both popup (data-product-bundle-popup) and PDP (data-bundle-discount on body)
  function getDiscountPercent(el) {
    const popup = el.closest('[data-product-bundle-popup]');
    const body = el.closest('[data-bundle-discount]');
    return Number(
      popup?.getAttribute('data-bundle-discount') ||
      body?.getAttribute('data-bundle-discount') ||
      0
    );
  }

  // Root container = popup on collection, bundle body on PDP
  function getBundleRoot(el) {
    return el.closest('[data-product-bundle-popup]') ||
      el.closest('[data-bundle-discount]') ||
      el.closest('[data-bundle-root]');
  }

  function updateBundleTotalPrice(root) {
    if (!root) return;
    const totalPriceEl = root.querySelector('[data-bundle-total-price]');
    const comparePriceEl = root.querySelector('[data-bundle-total-compare]');
    if (!totalPriceEl) return;

    const discountPercent = Number(
      root.getAttribute('data-bundle-discount') ||
      root.closest('[data-bundle-discount]')?.getAttribute('data-bundle-discount') ||
      0
    );

    let totalCents = 0;
    let compareCents = 0;

    root.querySelectorAll('.product_bundle_popup__item').forEach((item) => {
      const variantSelect = item.querySelector('[data-bundle-variant-select]');
      const option = variantSelect && variantSelect.selectedOptions[0];
      if (!option) return;
      totalCents += Number(option.dataset.priceCents || 0);
      compareCents += Number(option.dataset.comparePriceCents || 0);
    });

    const discountedTotalCents = discountPercent > 0
      ? Math.round(totalCents - (totalCents * discountPercent / 100))
      : totalCents;

    totalPriceEl.textContent = formatMoney(discountedTotalCents);

    if (comparePriceEl) {
      if (discountPercent > 0) {
        comparePriceEl.textContent = formatMoney(totalCents);
        comparePriceEl.style.display = '';
      } else if (compareCents > totalCents) {
        comparePriceEl.textContent = formatMoney(compareCents);
        comparePriceEl.style.display = '';
      } else {
        comparePriceEl.textContent = '';
        comparePriceEl.style.display = 'none';
      }
    }

    const discountTextEl = root.querySelector('[data-bundle-discount-text]');
    if (discountTextEl && discountPercent > 0) {
      const discountAmount = Math.round(totalCents * discountPercent / 100);
      discountTextEl.textContent = `Save ${formatMoney(discountAmount).replace(/\.00$/, '')} • ${discountPercent}% OFF`;
    }

    // Update main PDP price
    const pdpWrapper = document.querySelector('.product_single__right_wrapper');
    if (pdpWrapper) {
      const mainPriceEl = pdpWrapper.querySelector('[data-product-price-element]');
      const mainComparePriceEl = pdpWrapper.querySelector('[data-product-compare-at-price-element]');
      if (mainPriceEl) {
        mainPriceEl.textContent = formatMoney(discountedTotalCents);
      }
      if (mainComparePriceEl) {
        if (discountPercent > 0 || compareCents > totalCents) {
          mainComparePriceEl.textContent = formatMoney(discountPercent > 0 ? totalCents : compareCents);
        } else {
          mainComparePriceEl.textContent = '';
        }
      }
    }
  }

  document.addEventListener('click', async function (event) {

    // ── Open popup ──────────────────────────────────────────────
    const openButton = event.target.closest('[data-product-bundle-open-button]');
    if (openButton) {
      const wrapper = openButton.closest('.product_bundle_data');
      const popup = wrapper && wrapper.querySelector('[data-product-bundle-popup]');
      if (popup) {
        popup.classList.add('active');
        popup.setAttribute('aria-hidden', 'false');
        document.body.classList.add('product-bundle-popup-active');
      }
      return;
    }

    // ── Close popup ─────────────────────────────────────────────
    const closeButton = event.target.closest('[data-product-bundle-close-button]');
    if (closeButton) {
      const popup = closeButton.closest('[data-product-bundle-popup]');
      if (popup) {
        popup.classList.remove('active');
        popup.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('product-bundle-popup-active');
      }
      return;
    }

    // ── Click outside popup to close ───────────────────────────
    const popupOverlay = event.target.closest('[data-product-bundle-popup].active');
    if (popupOverlay && event.target === popupOverlay) {
      popupOverlay.classList.remove('active');
      popupOverlay.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('product-bundle-popup-active');
      return;
    }

    // ── Add to bag ──────────────────────────────────────────────
    const addButton = event.target.closest('[data-product-bundle-add-button]');
    if (!addButton) {
      return;
    }
    const isFinalSale = addButton.getAttribute('data-product-final-sale') === 'true';
    if (addButton) {
      const popup = addButton.closest('[data-product-bundle-popup]');
      const bundleBody = addButton.closest('[data-bundle-discount]');
      const container = popup || bundleBody || document;

      const inputs = container.querySelectorAll('[data-bundle-product-variant-id]');
      const bundleId = 'bundle-' + Date.now();
      const bundleTitle = popup?.getAttribute('data-bundle-title') || document.title || 'Bundle';
      const bundleDiscount = popup?.getAttribute('data-bundle-discount') ||
        bundleBody?.getAttribute('data-bundle-discount') || '0';

      let bundleImage = popup?.querySelector('.product_bundle_popup__items')?.getAttribute('data-featured-image') 
  || popup?.getAttribute('data-featured-image')
  || container.querySelector('.product_bundle_popup__items')?.getAttribute('data-featured-image')
  || '';

if (bundleImage && bundleImage.startsWith('//')) {
  bundleImage = 'https:' + bundleImage;
}


let bundleParentVariantId = popup?.querySelector('.product_bundle_popup__items')?.getAttribute('data-parent-variant-id') 
  || popup?.getAttribute('data-parent-variant-id')
  || container.querySelector('.product_bundle_popup__items')?.getAttribute('data-parent-variant-id')
  || '';

const bundleCustomDiscount = document.querySelector('.product_bundle_popup__body[data-bundle-discount]')?.getAttribute('data-bundle-discount')
  || bundleBody?.getAttribute('data-bundle-discount')
  || '';




const selectedVariantIds = Array.from(
  container.querySelectorAll('[data-bundle-product-variant-id]')
).map(input => `gid://shopify/ProductVariant/${input.value}`);



const selectedPrices = Array.from(
  container.querySelectorAll('[data-bundle-product-variant-id]')
).map(input => {
  const option = input.closest('.product_bundle_popup__item')
    ?.querySelector('[data-bundle-variant-select]')
    ?.selectedOptions[0];

  return Number(option?.dataset.priceCents || 0);
});



const subtotal = selectedPrices.reduce((sum, price) => sum + price, 0);

const discountedPrices = selectedPrices.map(price =>
  Math.round(price * (100 - bundleCustomDiscount) / 100)
);

console.log('selectedPrices', selectedPrices);
console.log('bundleCustomDiscount', bundleCustomDiscount);

const items = [{
  id: Number(bundleParentVariantId),
  quantity: 1,
  properties: {
  _bundle_variants: JSON.stringify(selectedVariantIds),
  _bundle_prices: JSON.stringify(discountedPrices),
  _bundle_subtotal: subtotal,
  _bundle_discount: bundleCustomDiscount,
  _final_sale: isFinalSale ? 'true' : ''

}
}];


      if (!items.length) return;
      addButton.disabled = true;
      addButton.childNodes[0].textContent = 'Adding…';

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items }),
        });


        if (!response.ok) throw new Error('Unable to add bundle to cart');

        if (popup) {
          popup.classList.remove('active');
          popup.setAttribute('aria-hidden', 'true');
          document.body.classList.remove('product-bundle-popup-active');
        }

        try {
          const res = await fetch(window.location.pathname + '?_=' + new Date().getTime());
          if (res.ok) {
            const htmlText = await res.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(htmlText, 'text/html');
            const cartDrawer = document.querySelector('[data-drawer-right].cart');
            const newContent = doc.querySelector('[data-ajaxcart-content]');
            const currentContent = cartDrawer ? cartDrawer.querySelector('[data-ajaxcart-content]') : null;
            console.log('items', items);
            if (newContent && currentContent) {
              currentContent.innerHTML = newContent.innerHTML;
              const newCount = doc.querySelector('[data-cart-item-count]')?.innerText || '';
              document.querySelectorAll('[data-cart-item-count], [data-cart-icon-full]').forEach(el => {
                el.innerText = newCount;
                parseInt(newCount) > 0 ? el.classList.remove('hide') : el.classList.add('hide');
              });
            }
            console.log("Need change");
            //  window.reinitCartSwiper();
          }
        } catch (e) {
          console.warn('Could not refresh cart drawer:', e);
        }

        const cartToggle = document.querySelector('[data-drawer-toggle][data-drawer-right-toggle]');
        if (cartToggle) cartToggle.click();

        addButton.disabled = false;
        addButton.childNodes[0].textContent = 'Add To Bag';

      } catch (error) {
        console.error(error);
        addButton.disabled = false;
        addButton.childNodes[0].textContent = 'Add To Bag';

      }
    }
  });

  // ── Variant pill click ────────────────────────────────────────
  document.addEventListener('click', function (event) {
    const pill = event.target.closest('[data-bundle-option-pill]');
    if (!pill) return;
    const item = pill.closest('.product_bundle_popup__item');

    if (!item) return;

    const optionIndex = pill.getAttribute('data-option-index');
    const optionGroup = item.querySelector('[data-bundle-option-group][data-option-index="' + optionIndex + '"]');
    if (!optionGroup) return;

    // Deselect pills in this group only
    optionGroup.querySelectorAll('[data-bundle-option-pill]').forEach((btn) => {
      btn.setAttribute('aria-pressed', 'false');
    });
    pill.setAttribute('aria-pressed', 'true');

    const variantSelect = item.querySelector('[data-bundle-variant-select]');
    if (!variantSelect) return;

    // Seed selectedValues from current variant so other options stay matched
    const currentHiddenInput = item.querySelector('[data-bundle-product-variant-id]');
    const currentVariantOption = Array.from(variantSelect.options).find(o => o.value == currentHiddenInput?.value);
    let currentParsedOptions = [];
    try { currentParsedOptions = JSON.parse(currentVariantOption?.dataset.options || '[]'); } catch (e) { }

    const selectedValues = [];
    currentParsedOptions.forEach((val, idx) => { selectedValues[idx] = val; });
    item.querySelectorAll('[data-bundle-option-pill][aria-pressed="true"]').forEach((btn) => {
      selectedValues[Number(btn.getAttribute('data-option-index'))] = btn.getAttribute('data-option-value');
    });

    const allVariants = Array.from(variantSelect.options).map((opt) => {
  let parsedOptions = [];
  try {
    parsedOptions = JSON.parse(opt.dataset.options);
  } catch (e) {}

  return {
    id: opt.value,
    available: opt.dataset.available === 'true',
    price: opt.dataset.price,
    price_cents: Number(opt.dataset.priceCents || 0),
    compare_price: opt.dataset.comparePrice,
    compare_price_cents: Number(opt.dataset.comparePriceCents || 0),
    image: opt.dataset.image,
    options: parsedOptions,
  };
});


        // Disable unavailable option pills
item.querySelectorAll('[data-bundle-option-group]').forEach((group) => {
  const optionIndex = Number(group.getAttribute('data-option-index'));

  group.querySelectorAll('[data-bundle-option-pill]').forEach((pill) => {
    const testValues = [...selectedValues];
    testValues[optionIndex] = pill.getAttribute('data-option-value');

   const matchedVariant = allVariants.find((variant) =>
  variant.options.every((val, idx) => testValues[idx] === val)
);

if (matchedVariant && matchedVariant.available) {
  pill.classList.remove('product_bundle_popup__option-pill--sold-out');
  pill.removeAttribute('disabled');
  pill.setAttribute('aria-disabled', 'false');

  // Remove cross icon if it exists
  pill.querySelector('.sold-out-cross')?.remove();

} else {
  pill.classList.add('product_bundle_popup__option-pill--sold-out');
  pill.setAttribute('disabled', 'disabled');
  pill.setAttribute('aria-disabled', 'true');

  // Add cross icon only once
  if (!pill.querySelector('.sold-out-cross')) {
    pill.insertAdjacentHTML(
      'beforeend',
      '<span class="sold-out-cross"></span>'
    );
  }
}

  });
});


    const matchingVariant = allVariants.find((v) =>
      v.options.every((val, idx) => selectedValues[idx] === val)
    );
    if (!matchingVariant) return;

    variantSelect.value = matchingVariant.id;
    if (currentHiddenInput) currentHiddenInput.value = matchingVariant.id;

    // Sync all group labels and pill states
    item.querySelectorAll('[data-bundle-option-group]').forEach((group) => {
      const idx = Number(group.getAttribute('data-option-index'));
      const val = selectedValues[idx] || matchingVariant.options[idx] || '';
      const label = group.querySelector('[data-bundle-option-selected]');
      if (label) label.textContent = val;
      group.querySelectorAll('[data-bundle-option-pill]').forEach((btn) => {
        btn.setAttribute('aria-pressed', btn.getAttribute('data-option-value') === val ? 'true' : 'false');
      });
    });

    // ── Price with discount ─────────────────────────────────────
    const discountPercent = getDiscountPercent(item);

    const priceEl = item.querySelector('[data-bundle-item-price]');
    if (priceEl) {
      if (discountPercent > 0) {
        const discountedCents = Math.round(
          matchingVariant.price_cents - (matchingVariant.price_cents * discountPercent / 100)
        );
        priceEl.innerText = formatMoney(discountedCents);
      } else {
        priceEl.innerText = matchingVariant.price || priceEl.innerText;
      }
    }

    const compareEl = item.querySelector('[data-bundle-item-compare]');
    if (compareEl) {
      if (discountPercent > 0) {
        compareEl.innerText = matchingVariant.price || '';
        compareEl.style.display = matchingVariant.price ? '' : 'none';
      } else if (matchingVariant.compare_price) {
        compareEl.innerText = matchingVariant.compare_price;
        compareEl.style.display = '';
      } else {
        compareEl.innerText = '';
        compareEl.style.display = 'none';
      }
    }

    // ── Image ───────────────────────────────────────────────────
    const imageEl = item.querySelector('.product_bundle_popup__item-image img');
    if (imageEl) {
      const src = matchingVariant.image || variantSelect.selectedOptions[0]?.dataset.image;
      if (src) imageEl.src = src;
    }

    updateBundleTotalPrice(getBundleRoot(item));
  });
}

// recommendations

function initCartRecSwiper() {
  if (typeof Swiper === 'undefined') return false;

  const el = document.querySelector('.cart-recommendations__swiper');
  if (!el) return false;

  if (el.swiper) {
    el.swiper.destroy(true, true);
    el.swiper = null;
  }

  new Swiper('.cart-recommendations__swiper', {
    slidesPerView: 1.5,
    spaceBetween: 12,
    allowTouchMove: true,
    navigation: {
      nextEl: '.cart-rec-next',
      prevEl: '.cart-rec-prev',
    },
    breakpoints: {
      750: {
        slidesPerView: 2.5,
        spaceBetween: 12,
      },
    },
  });

  return true;
}

window.initCartRecSwiper = initCartRecSwiper;

function startCartSwiperInit() {
  let attempts = 0;
  const interval = setInterval(function () {
    attempts++;
    const el = document.querySelector('.cart-recommendations__swiper');
    if (el && el.swiper) {
      clearInterval(interval);
      return;
    }
    const success = initCartRecSwiper();
    if (success || attempts >= 10) {
      clearInterval(interval);
    }
  }, 1000);
}

window.startCartSwiperInit = startCartSwiperInit;

// On page load
document.addEventListener('DOMContentLoaded', startCartSwiperInit);

// On cart drawer open
document.addEventListener('click', function (event) {
  if (event.target.closest('[data-drawer-toggle][data-drawer-right-toggle]')) {
    setTimeout(initCartRecSwiper, 300);
  }
});


// Direct Add to cart
document.addEventListener('click', async function (event) {
  const atcButton = event.target.closest('.custom_ajax_button');
  if (!atcButton) return;

  const variantId = atcButton.getAttribute('data-variantid');
  if (!variantId) return;

  event.preventDefault();

  atcButton.style.pointerEvents = 'none';
  const originalText = atcButton.innerText;
  atcButton.innerText = 'Adding…';

  const items = [{
    id: Number(variantId),
    quantity: 1
  }];

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items }),
    });

    if (!response.ok) throw new Error('Unable to add item to cart');

    try {
      const res = await fetch(window.location.pathname + '?_=' + new Date().getTime());
      if (res.ok) {
        const htmlText = await res.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlText, 'text/html');
        const cartDrawer = document.querySelector('[data-drawer-right].cart');
        const newContent = doc.querySelector('[data-ajaxcart-content]');
        const currentContent = cartDrawer ? cartDrawer.querySelector('[data-ajaxcart-content]') : null;

        if (newContent && currentContent) {
          currentContent.innerHTML = newContent.innerHTML;
          const newCount = doc.querySelector('[data-cart-item-count]')?.innerText || '';
          document.querySelectorAll('[data-cart-item-count], [data-cart-icon-full]').forEach(el => {
            el.innerText = newCount;
            parseInt(newCount) > 0 ? el.classList.remove('hide') : el.classList.add('hide');
          });
        }
      }
    } catch (e) {
      console.warn('Could not refresh cart drawer:', e);
    }

    const cartToggle = document.querySelector('[data-drawer-toggle][data-drawer-right-toggle]');
    if (cartToggle) cartToggle.click();

  } catch (error) {
    console.error(error);
  } finally {
    atcButton.style.pointerEvents = '';
    atcButton.innerText = originalText;
  }
});


